import { render, staticRenderFns } from "./purchaseHistory.vue?vue&type=template&id=019b3ec0"
import script from "./purchaseHistory.vue?vue&type=script&lang=js"
export * from "./purchaseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports